'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var RadioGroupContext = require('./RadioGroupContext.js');

var useRadioGroup = function () { return React.useContext(RadioGroupContext["default"]); };

exports["default"] = useRadioGroup;
//# sourceMappingURL=useRadioGroup.js.map
